import '../style.scss';
import { Button, ButtonSize, FillType } from 'views/components/atoms/button';
import { EstablishText } from 'views/components/atoms/establishes/text';

type BankSearchTextProps = {
  inputType: string;
  label: string;
  value?: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => void;
};

/**
 * 金融機関名カナ検索
 * @param props
 * @returns
 */
export const BankSearchText = (props: BankSearchTextProps) => {
  const { inputType, label, value, placeholder, onChange, onSearch } = props;

  return (
    <div className="BankSearchTextWrapper">
      <div className="BanckSearchTextLabel">{label}</div>
      <div className="BankSearchTextField">
        <EstablishText
          inputType={inputType}
          inputValue={value}
          setInputValue={(e) => onChange(e)}
          placeholder={placeholder}
        />
        <Button
          label="検索"
          fillType={FillType.primaryFill}
          buttonSize={ButtonSize.sizeXS}
          onClick={() => {
            onSearch();
          }}
        />
      </div>
    </div>
  );
};
